/*!
 *  (c)(r) 2008-2023 IT-Service Robert Frunzke
 */

import { str_trim } from './util.js';
import { startProgress, stopProgress } from './progress-util.js';
import { getPreferedMaxDialogWidth, getPreferedMaxDialogHeight } from './dialog-util.js';
import { showInfoToastWithLink } from './snackbar.js';
import { jQuery } from '../other/jquery-hooked.js';
import { mjt } from './i18ntexts.js';

import { MTemplates } from './templates.js';


export let MVPublish = function($) {

	// sort the options of a dropdown by its text
	function mj_sort_select_options( select ) {
		var opts = $('option',select).remove();
		opts.sort( function(a,b) {
			a = a.firstChild.nodeValue;
			b = b.firstChild.nodeValue;
			return a===b ? 0 : ( a>b ? 1 : -1 );
		} );
		opts.appendTo(select);
	}

	function open( media_ids, new_collection_name ) {
		if( media_ids.length == 0 ) return;
		$('#mpub-form').dialog('destroy');
		startProgress();

		if( typeof new_collection_name === 'undefined' ) new_collection_name = '';

		// reset dialog
		var mpub_publication = $('#mpub-publication').empty().hide();
		if( mpub_publication.data('select2') ) mpub_publication.select2('destroy');
		$('#mpub-c-collection').hide();
		$('#mpub-c-publication-url').hide();
		$('#mpub-publish-button').prop('disabled',true);

		// load publications
		var postdata = 'filter_by_publish_to_index_lists=1';
		$.postJSON('json/media/publish-channel_list', postdata, function(j) {
			if( !j || Object.size(j)==0 ) {
				$('#mpub-c-publication-hint').html(mjt('mpub-hint-no-publications'));
			} else {
				var publications = j;
				$('#mpub-c-publication-hint').html(mjt('mpub-hint-publication'));
				for( var k in publications ) {
					if( !publications.hasOwnProperty(k) ) continue;
					var pub = publications[k];
					var txt = pub.title+' ('+pub.template_title+')';
					if( !pub.active ) txt += ' '+mjt('mpub-inactive');
					$('<option/>')
						.attr('value',pub.name)
						.text(txt)
						.appendTo(mpub_publication);
				}
				mj_sort_select_options(mpub_publication);
				mpub_publication
					.prepend('<option value="">'+mjt('mpub-publication-select')+'</option>')
					.val('');	// selects first option
				mpub_publication.show().off().change( function() {
					var pub_name = mpub_publication.val();
					if( pub_name=='' ) {
						$('#mpub-c-collection').hide();
						$('#mpub-c-publication-url').hide();
					} else {
						// publication selected..
						var pub = publications[pub_name];
						startProgress();
						$('#mpub-c-collection').show();
						$('#mpub-c-publication-url').show();
						$('#mpub-publication-url').attr('href',pub.url).text(pub.url);
						var mpub_collection = $('#mpub-collection').empty();
						if( mpub_collection.data('select2') ) mpub_collection.select2('destroy');
						$('#mpub-c-new-collection-name').show();
						$('#mpub-new-collection-name').val(new_collection_name).off().on('change keyup onpaste',function() {
							$('#mpub-publish-button').prop('disabled',str_trim($(this).val())=='');
						}).trigger('change');
						$.postJSON('json/media/publish-lists_list', 'publication='+encodeURIComponent(pub_name), function(j) {
							$('#mpub-new-collection-name').select();
							if( !j || !j.lists || j.lists.length==0 ) {
								// no collections available
								mpub_collection.html('<option value="">'+mjt('mpub-collection-new')+'</option>');
							} else {
								// collections exist
								var lists = j.lists;
								for( var k=0; k<lists.length; ++k ) {
									var lst = lists[k];
									var txt = lst.title+' (' + (lst.count==1?mjt('mpub-collection-files-1'):mjt('mpub-collection-files')).replace('%1',lst.count)+')';
									$('<option/>')
										.attr('value',lst.list_id)
										.text(txt)
										.appendTo(mpub_collection);
								}
								mj_sort_select_options(mpub_collection);
								mpub_collection
									.prepend('<option value="">'+mjt('mpub-collection-new')+'</option>')
									.val('');	// selects first option
								mpub_collection.off().change( function() {
									var col_id = mpub_collection.val();
									if( col_id=='' ) {
										$('#mpub-c-new-collection-name').show();
										window.setTimeout( function() {
											$('#mpub-new-collection-name').select();
										}, 24 );
									} else {
										$('#mpub-c-new-collection-name').hide();
										$('#mpub-publish-button').prop('disabled',false);
									}
								});
								mpub_collection.select2();
								mpub_collection.trigger('change.select2');
							}
							stopProgress();
						});
						$('#mpub-publish-button').off().click( function() {
							// do publish ..
							startProgress(true);
							var col_id = mpub_collection.val();
							var post_data = 'media_ids='+encodeURIComponent(media_ids.join(','))+'&publication='+encodeURIComponent(pub_name)+'&list_id='+encodeURIComponent(col_id);
							if( col_id=='' ) post_data += '&new_list_title='+encodeURIComponent($('#mpub-new-collection-name').val());
							$.postJSON('json/media/publish-publish', post_data, function(j) {
								if( j && j.success ) {
									var pub_url = pub.url + '?list_id=' + j.list_id;
									showInfoToastWithLink(mjt('mpub-send-success'), pub_url, {buttonCopy2Clipboard: true});
									$('#mpub-form').dialog('destroy');
								}
								stopProgress();
							});
							return false;
						});
					}
				});
				mpub_publication.select2().nextAll('.select2').css('width','100%');
				mpub_publication.trigger('change.select2');
			}
			// show dialog
			$('#mpub-form').dialog( {
				modal:true, resizable:false,
				//position:{my:'center middle',at:'center',of:window,'collision':'flipfit'},
				dynWidth: function() {
					return Math.min(getPreferedMaxDialogWidth()-40,800);
				},
				dynHeight: function() {
					return Math.min(getPreferedMaxDialogHeight()+0,1000);
				},
				close:function(ev, ui) {
					$(this).dialog('destroy');
				},
			} ).show();
			stopProgress();
		});
	}

	return {
		open: MTemplates.queryDialogHTMLWrappedFn('form_media_publish',open),
	};

}(jQuery); // namespace MVPublish
